import React from 'react'
import { ExternalLink } from 'react-feather'

import { Footer } from '@frame/ui-components/footer'
import { Button } from '@frame/ui-primitives/button'
import { InfoCard } from '@frame/ui-primitives/info-card'

import { useRootContext } from '@frame/lib/context'
import { DataAttribute } from '@frame/types'

type Props = {
  consumerInitiated: boolean
  hasCompletedIrsTask: boolean
  displayName: string
}

export function CompleteFooter({ consumerInitiated, hasCompletedIrsTask, displayName }: Props) {
  const { events } = useRootContext()
  const footerButton = (
    <Button
      data-cy={DataAttribute.BTN_CONTINUE_TO_VERIFIER}
      applyCobranding
      onClick={() => {
        events.emit('close')
      }}
    >
      Continue to {displayName}
    </Button>
  )

  if (hasCompletedIrsTask) {
    return (
      <footer className="p-5">
        <InfoCard className="p-5">
          <div className="flex flex-row">
            <p className="text-base font-semibold text-moss-950">Speed up your verification</p>
            <div
              className="mx-2 flex flex-row items-center justify-center rounded bg-moss-300 px-1 text-xs font-medium text-electric-900"
              style={{ minWidth: '60px', minHeight: '20px' }}
            >
              Optional
            </div>
          </div>
          <p className="mt-2 text-sm font-normal text-moss-700">
            Approve the authorization now to skip the 3-5 day wait for IRS manual processing.
          </p>
          <Button
            className="mt-2"
            Icon={ExternalLink}
            intent="tertiary"
            onClick={(e) => {
              window.open(
                'https://help.truework.com/hc/en-us/articles/29447365469591-Speed-up-your-tax-verification',
                '_blank'
              )
              e.stopPropagation()
            }}
          >
            Get started
          </Button>
        </InfoCard>
      </footer>
    )
  }

  return (
    <>
      {consumerInitiated && (
        <Footer
          buttons={{
            primary: footerButton,
          }}
        />
      )}
    </>
  )
}
